import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { PayloadAction } from "@reduxjs/toolkit";
import { Lang, RTECreatePayload, RTEDeletePayload, RTEUpdatePayload, appRegistry, broadcasterSlice, isNewModel } from 'cdx-common';
import React, { useEffect, useState } from 'react';
import SocketIOClient, { Socket } from 'socket.io-client';
import { appStore } from 'store';
import { useSession } from './libraries/SessionProvider';

let lastBroadcastId: ModelId | undefined = undefined;


export const Broadcaster = (props: { children: React.JSX.Element; }) => {

    const [ioInstance, setIoInstance] = useState<Socket | undefined>(undefined);
    const [pageIsObsolete, setPageIsObsolete] = useState(false);
    const { user } = useSession();

    useEffect(() => {
        const currUrl = new URL(document.URL);
        //setIoInstance(SocketIOClient((currUrl.protocol === 'https' ? 'wss' : 'ws') + '://' + currUrl.host));
        setIoInstance(SocketIOClient(currUrl.origin));
    }, []);

    useEffect(() => {
        if (ioInstance) {
            ioInstance.emit('authaltered');
        }
    }, [user]);

    useEffect(() => {
        console.log('ioInstance changed', ioInstance);
        if (ioInstance) {

            appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));

            ioInstance.on('connect', () => {
                console.log('io connect');
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
                lastBroadcastId && ioInstance.emit('lastBroadcast', lastBroadcastId);
            });
            ioInstance.on('disconnect', () => {
                console.log('io disconnect');
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
            });
            ioInstance.on("connect_error", (event: any) => {
                console.log('io connect_error', event);
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
            });
            ioInstance.on("error", () => {
                console.log('io error');
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
            });
            ioInstance.on("reconnect", () => {
                console.log('io reconnect');
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
            });
            ioInstance.on("reconnect_attempt", () => {
                console.log('io reconnect_attempt');
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
            });
            ioInstance.on("reconnect_error", () => {
                console.log('io reconnect_error');
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
            });
            ioInstance.on("reconnect_failed", () => {
                console.log('io reconnect_failed');
                appStore.dispatch(broadcasterSlice.actions.setConnected(ioInstance.connected));
            });
            ioInstance.on('invalidate', () => {
                setPageIsObsolete(true);
                ioInstance.disconnect();
            });
            ioInstance?.on('actions', (data: PayloadAction<any>[], id?: ModelId) => {
                console.log('actions received', data);
                data.map(appStore.dispatch);
                onBroadcast(id);
            });
            ioInstance?.on('update', (data: RTEUpdatePayload<any>, id?: ModelId) => {
                console.log('update received', data);
                const foreignInfo = appRegistry.get(data.type);
                // a single model update
                if (isNewModel(data.id)) {
                    // creation (complete model attributes)
                    appStore.dispatch(foreignInfo?.slice?.actions?.upsertOne(data));
                } else {
                    // partial or complete update
                    console.log('foreignInfo', foreignInfo?.slice?.actions?.updateOne);
                    appStore.dispatch(foreignInfo?.slice?.actions?.updateOne({ id: data.id, changes: data.changes }));
                }
                foreignInfo?.rteUpdateHandlers?.map(p => appStore.dispatch(p(data)));
                onBroadcast(id);
            });
            ioInstance?.on('create', (data: RTECreatePayload<any>, id?: ModelId) => {
                console.log('create received', data);
                const foreignInfo = appRegistry.get(data.type);
                appStore.dispatch(foreignInfo?.slice?.actions?.upsertOne(data.attrs));
                onBroadcast(id);
            });

            ioInstance?.on('delete', (data: RTEDeletePayload, id?: ModelId) => {
                console.log('deletee received', data);
                const foreignInfo = appRegistry.get(data.type);
                if (foreignInfo?.slice && foreignInfo.slice.actions && foreignInfo.slice.actions.removeOne) {
                    appStore.dispatch(foreignInfo.slice.actions.removeOne(data.deletedId));
                }
                onBroadcast(id);
            });
        }
        return () => {
            if (ioInstance) {
                ioInstance.off();
                setIoInstance(undefined);
                appStore.dispatch(broadcasterSlice.actions.setConnected(false));
            }
        };
    }, [ioInstance]);

    const onBroadcast = (id?: ModelId) => {
        if (id) {
            if (!lastBroadcastId || id > lastBroadcastId) {
                lastBroadcastId = id;
            }
        }
    };


    return <>
        {props.children}
        <Dialog
            open={pageIsObsolete}
            disableEscapeKeyDown
            aria-labelledby="obsolete-page-title"
            aria-describedby="obsolete-page-description"
        >
            <DialogTitle id="obsolete-page-title">
                {Lang('BROADCASTER.PAGE_OBSOLETE_TITRE')}
            </DialogTitle>
            <DialogContent>
                <Typography id="obsolete-page-description">
                    {Lang('BROADCASTER.PAGE_OBSOLETE_MESSAGE')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={() => window.location.reload()}>
                    {Lang('BROADCASTER.RECHARGER_PAGE')}
                </Button>
            </DialogActions>
        </Dialog>
    </>;
};
